import { Image, StyleSheet, View } from '@react-pdf/renderer';
import React from 'react';
import layout from '../../../assets/layout_report.png';
import { EDULAI_BLUE, EDULAI_PURPLE } from '../../../styles/styleConsts';
import translations from '../../../translations/i18next';
import { map } from 'lodash';
import Footer from './Footer';
import Header from './Header';
import ReportText from './ReportText';
import { showUINumber } from '../../../utils/Report/ReportUtils';
import Stars from './Stars';
import ReportTextHtml from './ReportTextHtml';

const styles = StyleSheet.create({
  backgroundImage: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    opacity: 1
  },
  backgroundContainer: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    backgroundColor: '#5048E5',
    opacity: 0.12
  },
  section: {
    paddingVertical: 10,
    paddingHorizontal: 20,
    backgroundColor: '#fafafa'
  },
  title: {
    fontSize: 14,
    marginBottom: 10,
    color: EDULAI_BLUE,
    fontWeight: 'bold'
  },
  text: {
    fontSize: 10,
    marginBottom: 5,
    color: EDULAI_PURPLE
  },
  rightColumn: {
    fontSize: 40,
    textAlign: 'center',
    color: EDULAI_BLUE,
    fontWeight: 'bold'
  },
  mainContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  leftColumn: {
    flex: 0.8
  },
  rightColumnContainer: {
    flex: 0.5,
    display: 'flex',
    justifyContent: 'center'
  },
  headerTable: {
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  headerText: {
    fontSize: 11,
    fontWeight: 'bold',
    color: 'white',
    marginLeft: 10
  },
  skillNameTitle: {
    fontSize: 12,
    fontWeight: 'bold',
    color: 'white',
    marginLeft: 10
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 10,
    borderColor: '#f1f1f3',
    borderWidth: 1,
    borderStyle: 'solid',
    borderRadius: 8,
    backgroundColor: 'white',
    paddingVertical: 10,
    paddingHorizontal: 10
  },
  textColumn: {
    flex: 3
  },
  ratingColumn: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  stars: {
    flexDirection: 'row'
  },
  starImage: {
    width: 10,
    height: 10,
    marginHorizontal: 2
  },
  starImageUnselected: {
    width: 9,
    height: 9,
    marginHorizontal: 2
  },
  textRight: {
    fontSize: 12,
    color: EDULAI_BLUE,
    fontWeight: 'bold',
    marginLeft: 10
  }
});

const SkillsTablePage = ({ user, index, data }) => {
  return (
    <>
      <Image style={styles.backgroundImage} src={layout} fixed />
      <Header user={user} />
      {index === 0 ? (
        <ReportText style={{ marginBottom: 25, marginTop: 5, color: EDULAI_BLUE, fontSize: 12, fontWeight: 'bold' }}>
          {translations.t('skillsReport.skillsResultsTitle')}
        </ReportText>
      ) : (
        <View style={{ marginTop: 10 }} />
      )}
      <View style={{ justifyContent: 'center' }}>
        <View style={styles.headerTable}>
          <View style={{ flex: 0.8 }}>
            <View style={{ paddingRight: 3 }}>
              <View style={{ backgroundColor: EDULAI_PURPLE, padding: 10, borderTopLeftRadius: 8 }}>
                <ReportText style={styles.skillNameTitle}>{data.name.toUpperCase()}</ReportText>
              </View>
            </View>
          </View>
          <View
            style={{
              flex: 0.5,
              height: '100%',
              backgroundColor: EDULAI_BLUE,
              paddingTop: 10,
              paddingBottom: 10,
              borderTopRightRadius: 8
            }}
          >
            <ReportText style={styles.headerText}>{translations.t('skillsReport.skillsResultsValueTitle')}</ReportText>
          </View>
        </View>
        <View style={styles.mainContainer}>
          <View style={styles.leftColumn}>
            <View style={{ paddingRight: 2, paddingBottom: 3 }}>
              <View style={styles.section}>
                <ReportText style={styles.title}>1) {translations.t(`skillsReport.strengths`)}</ReportText>
                <ReportTextHtml style={styles.text}>{data.strengths}</ReportTextHtml>
              </View>
            </View>

            <View style={{ paddingRight: 2, paddingBottom: 3 }}>
              <View style={styles.section}>
                <ReportText style={styles.title}>2) {translations.t(`skillsReport.weaknesses`)}</ReportText>
                <ReportTextHtml style={styles.text}>
                  {data.mediumWeaknesses}
                  {data.lowWeaknesses}
                </ReportTextHtml>
              </View>
            </View>

            <View style={{ paddingRight: 2 }}>
              <View style={styles.section}>
                <ReportText style={styles.title}>3) {translations.t(`skillsReport.areasDevelopments`)}</ReportText>
                <ReportTextHtml style={styles.text}>{data.developmentArea}</ReportTextHtml>
              </View>
            </View>
          </View>

          <View style={styles.rightColumnContainer}>
            <View style={styles.backgroundContainer} />
            <ReportText style={styles.rightColumn}>{translations.t('forms.total')}</ReportText>
            <ReportText style={styles.rightColumn}>{showUINumber(data.score)}</ReportText>
          </View>
        </View>
      </View>

      {map(data.subSkills, (subSkill, i) => {
        return (
          <View key={subSkill.description} style={[styles.row, i === 0 && { marginTop: 20 }]} minPresenceAhead={60}>
            <View style={styles.textColumn}>
              <View style={{ display: 'flex', flexDirection: 'row', flex: 1, paddingRight: 25 }}>
                <ReportText style={{ fontSize: 10 }}>{i + 1}. </ReportText>
                <ReportText style={{ fontSize: 10 }}>{subSkill.description}</ReportText>
              </View>
            </View>
            <View style={styles.ratingColumn}>
              <Stars rating={showUINumber(subSkill.score || 0)} />
              <ReportText style={styles.textRight}>{showUINumber(subSkill.score || 0)}</ReportText>
            </View>
          </View>
        );
      })}
      <Footer />
    </>
  );
};

export default SkillsTablePage;
